import { ApiService } from "../..";

export const updateSampleStatusRejected = (sampleId: string) => {
  return ApiService.baseAction(
    `sample/update_status_rejected/${sampleId}`,
    { },
    "post"
  );
};
